import classNames from 'classnames';
import { forwardRef } from 'react';
import { useController } from 'react-hook-form';
import ReactPhoneNumberInput from 'react-phone-number-input';

import css from './phone-input.css';

interface PhoneInputProps {
  label?: string;
  value?: string;
  placeholder?: string;
  onChange: (value: string | undefined) => void;
  onBlur?: () => void;
  className?: string;
  error?: string;
}

export const PhoneInput = forwardRef<typeof ReactPhoneNumberInput, PhoneInputProps>(
  ({ label, className, error, ...inputProps }, _ref) => {
    return (
      <div className={classNames(css.wrapper, className)}>
        {label && <span className={css.span}>{label}</span>}
        <ReactPhoneNumberInput {...inputProps} className={css.input} />
        {error && (
          <div className={css.error}>
            <p>{error}</p>
          </div>
        )}
      </div>
    );
  }
);

type ControlledInputProps = Pick<
  PhoneInputProps,
  'onBlur' | 'placeholder' | 'label' | 'className'
> & {
  name: string;
  onChange?: (value: string | undefined) => void;
};

export const ControlledPhoneInput = ({ name, ...props }: ControlledInputProps) => {
  const controller = useController({ name });
  return (
    <PhoneInput {...props} {...controller.field} error={controller.fieldState.error?.message} />
  );
};
